<template>
  <div id="cart-page" style="position: relative" v-if="cart">
    <Note collection="carts" :objectId="$route.params.id" />
    <h1 style="margin: 20px">Cart information</h1>
    <table style="margin: 0 auto">
      <tr v-if="company"><td>Business Partner</td><td><router-link :to="{ name: 'companyPage', params: { id: company.id } }">{{company.name}}</router-link></td></tr>
      <tr><td>Code</td><td>{{cart.code}}</td></tr>
      <tr v-if="cart.externalCartId"><td>External cart</td><td>{{cart.externalCartId}}</td></tr>
      <tr><td>Status</td><td>{{cart.status}}</td></tr>
      <tr v-if="cart.comment"><td>External cart</td><td>{{cart.comment}}</td></tr>
      <tr v-if="cart.contactDetails && cart.clientId"><td>Contact name</td><td><router-link :to="{ name: 'userProfile', params: { id: cart.clientId } }">{{cart.contactDetails.firstName}} {{cart.contactDetails.lastName}}</router-link></td></tr>
      <tr v-else-if="cart.contactDetails"><td>Contact name</td><td>{{cart.contactDetails.firstName}} {{cart.contactDetails.lastName}} </td></tr>
      <tr v-if="cart.contactDetails"><td>Contact phone</td><td><router-link :to="{ name: 'call', query: { phoneNumber: cart.contactDetails.phoneNumber } }">{{cart.contactDetails.phoneNumber}}</router-link></td></tr>
      <tr v-if="cart.contactDetails"><td>Contact email</td><td>{{cart.contactDetails.email}}</td></tr>
      <tr v-if="cart.billingDetails"><td>Billing name</td><td>{{cart.billingDetails.firstName}} {{cart.billingDetails.lastName}} </td></tr>
      <tr v-if="cart.billingDetails"><td>Company name</td><td>{{cart.billingDetails.companyName}} </td></tr>
      <tr v-if="cart.billingDetails"><td>Company code</td><td>{{cart.billingDetails.businessCode}} </td></tr>
      <tr v-if="cart.billingDetails"><td>Company vat</td><td>{{cart.billingDetails.vatCode}} </td></tr>
    </table>
    <h1 style="margin: 20px">Items</h1>
    <table style="margin: 0 auto">
      <tr>
        <th>Job</th><th>Product</th><th>External ID</th><th>Delivered At</th><th>Order</th><th>Location</th><th>Unit cost</th><th>Amount</th><th>Distance cost</th><th>Total cost</th><th>URL</th>
      </tr>
      <tr v-for="item, i in cart.items" :key="item.externalItemId">
        <td>{{$store.state.jobs[item.jobId].localizedTitle.lt}}</td>
        <td>{{item.productName}}</td>
        <td>{{item.externalItemId}}</td>
        <td><span v-if="item.deliveredAt">{{new Date(item.deliveredAt).toLocaleString()}}</span></td>
        <td><router-link :to="{ name: 'orderPage', params: { id: item.orderId } }">{{item.orderId}}</router-link></td>
        <td>{{item.location.description}}</td>
        <td>{{(item.price.adjustedUnitCost / 100).toFixed(2)}}</td>
        <td>{{item.amount}}</td>
        <td>{{(item.price.distanceCost / 100).toFixed(2)}}</td>
        <td>{{(item.price.total / 100).toFixed(2)}}</td>
        <td><span v-if="cart.clientSecret && !item.orderId"><a :href="getItemLink(i)" target="_blank">Client link</a></span></td>
      </tr>
    </table>
    <!-- {{cart}} -->
  </div>
</template>

<style scoped lang="less">
#cart-page {
  table {
    td, th {
      border: 1px solid #999;
      border-collapse: collapse;
      margin: 0;
      padding: 10px;
    }
  }
}
</style>

<script>
import api from "../services/api";
import Note from '../components/Note.vue';

export default {
  name: "home",
  components: {
    Note
  },
  methods: {
    getItemLink: function(index) {
      return 'http://discontract.com/lt-LT/cart/' + this.cart.id + '/' + index + '?cs=' + this.cart.clientSecret;
    },
  },
  data: function () {
    return {
      cart: false,
      contact: null,
      company: null
    };
  },
  mounted() {},
  created: async function () {
    const id = this.$route.params.id;
    const cart = (await api.getCart(id)).cart;
    this.company = await api.getCompany(cart.companyId);
    document.title = 'Cart';
    // if (cart.contactId) {
    //   this.contact = (await api.getContactsByIds([cart.contactId]))[0];
    // }
    this.cart = cart;
    // console.log(this.chat);
  },
};
</script>
